module.exports = __webpack_public_path__ + "static/media/down-arrow.82230657.svg";